import React, { useEffect, useState, useContext } from "react";
import MDBox from "components/MDBox";
import { useCalendlyEventListener, InlineWidget } from "react-calendly";

import { UserContext } from "context";

const token = process.env.REACT_APP_BEARER_TOKEN;
const apiUrl = process.env.REACT_APP_AUTH_API_URL;

const Calendar = () => {
  const { user } = useContext(UserContext);

  const fetchCalendlyDetails = async (eventUri) => {
    try {
      const response = await fetch(eventUri, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();

      const startTime = data.resource.start_time;
      await updateNextCallDate(startTime);
    } catch (error) {
      console.error("Error fetching event details:", error); // More descriptive error logging
    }
  };

  const updateNextCallDate = async (startTime) => {
    try {
      const userId = user.id; // Assuming user context provides user ID
      const response = await fetch(`${apiUrl}/calendar/update_next_call_date.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ userId, startTime }),
      });

      const result = await response.json();
      if (response.ok) {
        console.log("Successfully updated next call date:", result);
      } else {
        console.error("Error updating next call date:", result);
      }
    } catch (error) {
      console.error("Error updating next call date:", error);
    }
  };

  useCalendlyEventListener({
    onEventScheduled: async (e) => {
      const eventUri = e.data.payload.event.uri;
      fetchCalendlyDetails(eventUri);
    },
  });

  const fullName = user?.name && user?.surname ? `${user.name} ${user.surname}` : "";

  return (
    <InlineWidget
      url="https://calendly.com/staff-permessiok/30min"
      prefill={{ 
        email: user?.email || "",
        name: fullName
      }}
    />
  );
};

export default Calendar;
